<template>
    <div class="card" data-testid="tasks-page">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <b>Úkoly</b>
                </div>
                <div class="col-md-6">
                </div>
            </div>
        </div>
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                    Filtrování
                </div>
                <div class="col-md-8 text-center">
                    <select v-model="taskType" class="mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="typ úkolu" data-testid="tasks-feed-select">
                        <option :value="0">mé úkoly</option>
                        <option :value="1">mnou zadané úkoly</option>
                    </select>

                    <button class="btn btn-sm btn-outline-danger" value="scheduled" v-if="selectedStates.indexOf('scheduled') < 0" @click="selectedStates.push('scheduled')" data-testid="tasks-filter-scheduled">nesplněné</button>
                    <button class="btn btn-sm btn-success" value="scheduled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('scheduled'), 1)" data-testid="tasks-filter-scheduled">nesplněné</button>

                    <button class="btn btn-sm btn-outline-danger" value="completed" v-if="selectedStates.indexOf('completed') < 0" @click="selectedStates.push('completed')" data-testid="tasks-filter-completed">dokončené</button>
                    <button class="btn btn-sm btn-success" value="completed" v-else="" @click="selectedStates.splice(selectedStates.indexOf('completed'), 1)" data-testid="tasks-filter-completed">dokončené</button>

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('canceled') < 0" @click="selectedStates.push('canceled')" data-testid="tasks-filter-canceled">zrušené</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('canceled'), 1)" data-testid="tasks-filter-canceled">zrušené</button>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="getDoctorsDayTasks()" class="btn btn-secondary btn-sm" data-testid="tasks-refresh"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="tasks.length > 0">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1"></th>
                    <th class="col-sm-2">Klient</th>
                    <th class="col-sm-2">Druh</th>
                    <th class="col-sm-4">Úkol</th>
                    <th class="col-sm-2">Úkol pro</th>
                    <th class="col-sm-1"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in tasks" class="card-text">
                    <tr class="row m-0" :data-testid="'tasks-row-' + task.id">
                        <td class="align-middle col-sm-1">
                            <task-change-state v-on:update="getDoctorsDayTasks" :actual-state="task.state" :task-id="task.id"></task-change-state>
                        </td>
                        <td class="align-left col-sm-2" :data-testid="'tasks-client-' + task.id">
                            <template v-if="task.client !== null">
                                <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: task.client.id }}" :data-testid="'tasks-client-link-' + task.id"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> <b>{{ task.client.full_name }}</b><br><span v-if="task.client.insurance_number">ČP: <b>{{ task.client.insurance_number }}</b></span> <span v-else="">RČ: <b>{{ task.client.p_i_n }}</b></span>
                            </template>
                            <template v-else="">
                                <span>- - -</span>
                            </template>
                        </td>
                        <td class="align-middle col-sm-2" :data-testid="'tasks-kind-' + task.id">
                            {{ task.template !== null ? task.template.name : 'jiný' }}
                        </td>
                        <td class="col-sm-4" :data-testid="'tasks-text-' + task.id">
                            <template v-if="editingTaskId === task.id ">
                                <form class="form-inline" @submit.prevent="putTask(task)">
                                    <input v-model="editingTask.text" type="text" class="form-control ml-sm-1 col-sm-10 mr-sm-2" aria-describedby="noteHelp" id="text" :data-testid="'tasks-edit-input-' + task.id">
                                    <button v-if="!waitForSave" type="submit" class="btn btn-primary" :data-testid="'tasks-edit-save-' + task.id">Uložit</button>
                                    <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                </form>
                            </template>
                            <template v-else="">
                                <button @click="editTask(task.text, task.id)" class="btn btn-sm btn-link text-secondary" :data-testid="'tasks-edit-' + task.id"><i class="fa fa-pencil" aria-hidden="true"></i></button> {{ task.template !== null ? task.template.text + ' - ' : '' }}{{ task.text }}
                            </template>
                        </td>
                        <td class="col-sm-2" :data-testid="'tasks-assignees-' + task.id">
                            <template v-for="(assigned_medic, index) in task.assigned_medics">
                                {{ assigned_medic.fullname }}<template v-if="index != task.assigned_medics.length - 1">, </template>
                            </template>
                        </td>
                        <td class="col-sm-1 text-right">
                            <i v-tooltip="{
                                content: 'vytvořil/a: <b>' + task.created_by.fullname + '</b>' + (task.completed_by !== null ? '<br>splnil/a: <b>' + task.completed_by.fullname + '</b>': ''),
                                placement: 'bottom-center',
                                classes: ['info']}"
                               class="fa fa-2x fa-info-circle text-info">
                            </i>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="tasksPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="" data-testid="tasks-empty">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (nebyl nalezen žádný úkol)
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import moment from 'moment'
  // import TaskChangeDoctor from '../components/TaskChangeDoctor.vue'
  import TaskChangeState from '../components/TaskChangeState.vue'

  import Datepicker from 'vuejs-datepicker'

  export default {
    data () {
      return {
        visits_header_title: '',
        setting: require('../../../variables.js'),
        get_params: {
          date: ''
        },
        selectedStates: [
          'scheduled'
        ],
        print_date: '',
        taskTemplate: '', // localStorage.getItem('userid'),
        taskTemplates: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        selectedDate: '',
        tasks: false,
        tasksError: false,
        tasksPending: true,
        clientPreviousTasks: false,
        clientPreviousTasksError: false,
        clientPreviousTasksPending: true,
        waiting: true,
        editingTaskId: false,
        editingTask: {},
        waitForSave: false,
        openedTaskId: false,
        openedTaskEvaluation: '',
        updatedTask: {
          evaluation: '',
          state: '',
          client_id: false,
          include_result_to_email: true
        },
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        state: '',
        openedClientTaskId: false,
        taskType: 0
      }
    },
    mixins: [apiMixin],
    methods: {
      editTask (text, id) {
        this.editingTaskId = id
        this.editingTask = {
          text: text
        }
      },
      putTask () {
        this.waitForSave = true
        this.$http.put('task/' + this.editingTaskId, this.editingTask, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingTaskId = false
          this.editingTask = {}
          this.getDoctorsDayTasks()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      getDoctorsDayTasks () {
        let getParams = {
          states: JSON.stringify(this.selectedStates)
        }
        if (this.taskType === 0) {
          this.getTasksOld(getParams)
        } else {
          this.getTasksCreatedByMedic(getParams)
        }
      }
    },
    beforeMount () {
      this.getDoctorsDayTasks()
    },
    watch: {
      taskType (val, oldVal) {
        if (val !== oldVal) {
          console.log('jupii')
          this.getDoctorsDayTasks()
        }
      },
      selectedStates: function (val) {
        // localStorage.setItem('home_states', JSON.stringify(val))
        // if (!this.waiting) {
        this.getDoctorsDayTasks()
        // }
      },
      assignedTo: function () {
        // if (!this.waiting) {
        this.getDoctorsDayTasks()
        // }
      },
      selectedDate: function (val) {
        // localStorage.setItem('home_date', moment(val).format('DD.MM.YYYY'))
        this.selected_date = moment(val)
        this.setDateAndLoad()
      }
    },
    components: {
      // TaskChangeDoctor,
      TaskChangeState,
      Datepicker
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Task/components/Tasks.vue?18f5c201